import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MessagebarService } from "../service/messagebar.service";
import { RetailUserService } from "../service/retailuser.service";
import { CartSubmitDialog } from "../cart/cart-submit-dialog";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

import { APIService } from "../service/api.service";
import { Response } from "@angular/http";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { BirchUtil } from "../service/birchutil";
import { CartItemService, CartItem } from "../service/cart.service";

import { Location, LocationService } from "../service/location.service";
import { CartComponent } from "../cart/cart.component";

import { EMPTY, of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

@Component({
  selector: "app-create-guest-account",
  templateUrl: "./create-guest-account.component.html",
  styleUrls: ["./create-guest-account.component.scss"],
  providers: [LocationService],
})
export class CreateGuestAccountComponent implements OnInit {
  // private userLatitude: number = 0;
  // private userLongitude: number = 0;
  // private nearByLocationsSet: boolean = false;
  // private Locations: Location[] = locations;
  // private selected: Location;
  stores: Location[] = LocationService.locations;

  // [
  //   {StoreID:1,Branch:"Anacortes"},
  //   {StoreID:2,Branch:"Bellingham"},
  //   {StoreID:3,Branch:"Everett"},
  //   {StoreID:4,Branch:"Vernon"},
  //   {StoreID:5,Branch:"Sitka"},
  // ];
  cartItems: CartItem[] = CartItemService.currentItems;

  isEdit = false;
  isBusy = false;
  errorMsg: string = null;
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phone: string;
  altPhone: string;
  defaultStore: Location;
  password: string;
  passwordConfirm: string;
  fleetUpdates: boolean;
  userAccountForm: FormGroup;
  // flags so phone will get validate on loose focus
  checkAltPhone = false;
  checkPhone = false;

  constructor(
    private router: Router,
    private apiService: APIService,
    private retailUserService: RetailUserService,
    private dialog: MatDialog,
    private cartItemService: CartItemService,
    private msgBar: MessagebarService,
    private locationService: LocationService,
  ) {
    this.defaultStore = this.stores[0];
    this.userAccountForm = new FormGroup({
      txtFirstName: new FormControl("", Validators.required),
      txtLastName: new FormControl("", Validators.required),
      txtCompany: new FormControl(""),
      txtEmail: new FormControl("", Validators.required),
      txtPhone: new FormControl("", [
        Validators.required,
        BirchUtil.phoneValidator,
      ]),
      txtAltPhone: new FormControl("", BirchUtil.phoneValidator),
      txtDefaultStore: new FormControl(""),
      txtPassword: new FormControl(""),
      // 'txtPasswordConfirm': new FormControl('', Validators.required),
      chkFleetUpdates: new FormControl(""),
    });
  }

  ngOnInit() {
    // if a user is logged in then we are editing an existing
    if (this.retailUserService.retailUserID) {
      this.isEdit = true;
      let user = this.retailUserService.retailUser;
      this.firstName = user["FirstName"];
      this.lastName = user["LastName"];
      this.company = user["Company"];
      this.email = user["Email"];
      this.phone = user["Phone"];
      this.altPhone = user["AltPhone"];
      this.defaultStore = user["DefaultStore"];
      this.fleetUpdates = user["FleetUpdates"];
      this.password = user["Password"];
      // this.userAccountForm.controls['txtPassword'].clearValidators();
      // this.userAccountForm.controls['txtPasswordConfirm'].clearValidators();
      let stores = this.stores.filter((x) => x.Branch == user["DefaultStore"]);
      if (stores.length > 0) {
        this.defaultStore = stores[0];
      }
    }
  }

  loginPage() {
    this.router.navigate(["/login"]);
  }

  specialsPage() {
    this.router.navigate(["/specials"]);
  }
  routeStore() {
    this.router.navigate(["/items"]);
  }
  createAccount() {
    // verify password and confirm
    // verify the new and confirm are the same
    this.errorMsg = null;
    // if (!this.isEdit && this.password.localeCompare(this.passwordConfirm) !== 0) {
    //   this.msgBar.addAlert('Your new password and confirm password do not match', 'warning');
    //   return;
    // }
    this.isBusy = true;
    if (this.fleetUpdates === undefined) {
      this.fleetUpdates = false;
    }

    const originalEmail = this.email;
    const encodedEmail = encodeURIComponent(originalEmail);
    const desiredEmail = encodedEmail.replace(/%40/g, "@");
    let json = `{
    "FirstName" : "${this.firstName}",
    "LastName" : "${this.lastName}",
    "Company" : "${this.company}",
    "Email" : "${desiredEmail}",
    "Phone" : "${this.phone}",
    "AltPhone" : "${this.altPhone}",
    "Password": "Guest@123",
    "DefaultStore": "${this.defaultStore.Branch}",
    "SendEmail": "${this.fleetUpdates}",
    "IsGuest": true
    }`;
    json = json.replace(/undefined/g, "");
    if (this.isEdit) {
      try {
        this.apiService
          .Put("retailuser/" + this.retailUserService.retailUserID, json)
          .subscribe(
            (data) => {
              sessionStorage.setItem("retailuser", JSON.stringify(data));
              this.retailUserService.retailUser = data;
              this.retailUserService.retailUserID = data["RetailUserID"];
              this.retailUserService._firstName = data["FirstName"];

              this.msgBar.addAlert("Account Updated", "info");
            },
            (err) => {
              let errMsg = "Unable to update your account! ";
              if (err instanceof Response) {
                if (
                  json["message"] !== undefined &&
                  json["message"].length > 0
                ) {
                  errMsg += json["message"];
                }
              }
              this.msgBar.addAlert(errMsg, "danger");
              this.isBusy = false;
            },
            () => {
              this.isBusy = false;
            },
          );
      } catch (error) {
        let msg = "Error updating account ";
        console.log(<any>error);
        if (typeof error === "string" && error.length > 0) {
          msg += error;
        }
        this.msgBar.addAlert(msg, "danger");
      }
    } else {
      // Its new
      try {
        this.apiService.Post("retailuser/guest", json).subscribe(
          (data) => {
            try {
              let pwd = "Guest@123";
              this.retailUserService.login(desiredEmail, pwd).subscribe(
                (logindata) => {
                  this.loginSuccess(logindata);
                },
                (err) => this.loginError(<any>err),
              );
            } catch (ex) {
              console.error("Error logging in" + ex);
            }
          },
          (err) => {
            let errMsg = "Unable to create your account! ";
            if (err instanceof Response) {
              if (err["message"] !== undefined && err["message"].length > 0) {
                errMsg += err["message"];
                this.errorMsg = errMsg;
              }
            }
            this.msgBar.addAlert(errMsg, "danger");
            this.isBusy = false;
          },
          () => {
            this.isBusy = false;
          },
        );
      } catch (error) {
        let msg = "Error creating account ";
        console.log(<any>error);
        if (typeof error === "string" && error.length > 0) {
          msg += error;
        }
        this.msgBar.addAlert(msg, "danger");
      }
    }
  }
  showSubmitModal(): void {
    const dialogRef = this.dialog.open(CartSubmitDialog, { width: "40%" });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
      this.routeStore();
    });
  }
  private loginSuccess(data) {
    let delivery = sessionStorage.getItem("Delivery");
    if (delivery.toLocaleLowerCase() === "false") {
      let notess = sessionStorage.getItem("notes");
      let storee = sessionStorage.getItem("store");

      if (data.RetailUserID != undefined) {


        let cmd = "retailuser/" + data.RetailUserID + "/cartcurrent";
        // return this.http.get(this.baseUrl + cmd, {headers: this.apiService.httpHeaders()})
        //   .map(this.extractCartData)
        //   .catch(this.handleError);
        return this.apiService.Get(cmd).subscribe(
          (cartData) => {
            
            let storePayload = this.buildStorePayload(storee);
            console.log("Store Payload: ", storePayload);
            let cmd2 =
              "retailuser/" + data.RetailUserID + "/cart/" + cartData[0].CartID;
            return this.apiService
              .Put(cmd2, JSON.parse(storee))
              .subscribe(() => {
                this.showSubmitModal(); // Open Confirmation Modal
                this.cartItemService
                  .PutCartNotes(CartComponent.notes)
                  .subscribe(
                    (cartt) => {
                      console.log("Updated Notes: " + cartt);
                      this.cartItemService.GetUserCurrentCart();
                      CartComponent.notes = "";
                      this.router.navigate(["/items"]);
                      let fromGuest = sessionStorage.getItem("guestCheckout");
                      if (fromGuest && fromGuest === "true") {
                        sessionStorage.removeItem("guestCheckout");
                        this.retailUserService.logout();
                      }
                    },
                    (error) => {
                      
                      const msg = "Unable to update notes";
                      console.log(<any>error);
                    },
                  );
              });
          },
          (err) => {
            
            console.error("Error getting current cart: ", err);
          },
        );
      }

      this.msgBar.addAlert(
        "Welcome " + this.retailUserService.firstName(),
        "success",
      );
      // https://api.birchequipment.com/retailuser/1848/cartcurrent
      
      this.isBusy = false;
      this.retailUserService.logout();
      // this.router.navigate(["/specials"]);
      // this.router.navigate(['/cart']);
    } else {
      if (this.retailUserService.isLoggedIn() && this.cartItems.length > 0) {
        this.router.navigate(["/delivery"]);
      }
    }
  }

  /** Update notes only when notes exist; otherwise do nothing */
  private updateCartNotes$(
    retailUserId: string | number,
    cartId: string | number,
    notes: string,
  ) {
    if (!notes) return of(null);

    const cmd = `retailuser/${retailUserId}/cart/${cartId}/notes`;
    const notesObj = { notes };

    return this.apiService.Post(cmd, JSON.stringify(notesObj)).pipe(
      tap((notesData: any) => {
        console.log("Notes updated:", notesData);
      }),
    );
  }

  /** Builds payload for store update */
  private buildStorePayload(storeStr: string): Record<string, any> {
    if (!storeStr) return {};

    try {
      return { Store: JSON.parse(storeStr) };
    } catch (e) {
      console.warn("Invalid store JSON in sessionStorage:", e);
      return {};
    }
  }

  /** Original fallback when RetailUserID not present */
  private onLoginSuccessFallback(data: any): void {
    this.msgBar.addAlert(
      `Welcome ${this.retailUserService.firstName()}`,
      "success",
    );

    this.isBusy = false;
  }
  private loginError(err) {
    let errMsg = "Unable to login";
    if (err instanceof Response) {
      let resp: Response = err;
      let body = resp.json();
      if (body.Message) {
        errMsg = body.Message;
      }
    }
    this.msgBar.addAlert(errMsg, "warning");
    this.retailUserService.loginSet(false);
    this.isBusy = false;
  }

  setLocation() {
    let self = this;
    this.locationService.setNearByLocations().subscribe((locations) => {
      self.defaultStore = this.stores[0];
    });
  }

  onCancel() {
    if (this.userAccountForm.dirty) {
      // warn about leaving page
      let leave: boolean = confirm(
        "You have unsaved data! Are you sure you want to leave?",
      );
      if (!leave) {
        return;
      }
    }
    history.back();
  }
}
